const Card = ({ title, value, description, background }) => {
    return (
        <div className={`p-4 rounded-lg shadow-md text-left bg-opacity-30 ${background}`}>
            <h2 className={`font-bold text-lg`}>{title}</h2>
            <p className="text-2xl font-semibold my-2">{value}<span className="text-sm ml-2 text-gray-500">{description}</span></p>
        </div>
    );
};

export default Card;